import { Stack } from '@mui/material';

import { Typography, InfoOutlinedIcon } from '@occc-app/design-system';
import { Tooltip } from '@occc/ui-design-system';

type EarningMechanismAwardSelectorProps = {
  isAwardVouchers: boolean;
  title: string;
};

export const EarningMechanismAwardSelectorTitle = ({
  isAwardVouchers,
  title,
}: EarningMechanismAwardSelectorProps) => {
  if (isAwardVouchers) {
    return (
      <Stack direction='row' alignItems='center' spacing={1} mb={2}>
        <Typography variant='subtitle1'>{title}</Typography>
        <Tooltip title='Award must be published to be selected'>
          <InfoOutlinedIcon fontSize='small' sx={{ color: 'silver' }} />
        </Tooltip>
      </Stack>
    );
  }

  return (
    <Typography variant='subtitle1' paragraph>
      {title}
    </Typography>
  );
};
